/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { invDependencies } from './dependenciesInv.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyDependencies } from './dependenciesMultiply.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createDivide } from '../../factoriesAny.js';
export var divideDependencies = {
  divideScalarDependencies: divideScalarDependencies,
  equalScalarDependencies: equalScalarDependencies,
  invDependencies: invDependencies,
  matrixDependencies: matrixDependencies,
  multiplyDependencies: multiplyDependencies,
  typedDependencies: typedDependencies,
  createDivide: createDivide
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDivide.generated.js
// module id = 87
// module chunks = 0